export const DATE_FORMAT = {
  DEFAULT: "yyyy-MM-dd",
  VISUAL: "yyyy/MM/dd"
};

export enum NAME_TYPE {
  SHORT,
  FULL
}
